export enum PersonalizationResourceType {
  "Story" = "Story",
  "Video" = "Video",
  "Interactive" = "Interactive",
  "Company" = "Company",
  "Topic" = "Topic",
  "Feature" = "Feature",
  "Author" = "Author",
  "Person" = "Person",
  "Section" = "Section",
  "Ni" = "Ni",
  "Wire" = "Wire",
  "Newsletter" = "Newsletter",
  "Quicktake" = "Quicktake",
  "Currency" = "Currency",
  "Region" = "Region",
  "Event" = "Event",
  "External" = "External",
  "Slideshow" = "Slideshow",
  "Dataarticle" = "Dataarticle",
  "Category" = "Category",
  "Tracker" = "Tracker",
  "Index" = "Index",
  "Country" = "Country",
  "Organization" = "Organization",
  "City" = "City",
  "Commodity" = "Commodity",
  "Fund" = "Fund",
  "Classification" = "Classification",
  "Series" = "Series",
  "Location" = "Location",
}

export enum PopularInteraction {
  VIEW = "VIEW",
  SHARE = "SHARE",
  MERGE = "MERGE",
  QUEUE = "QUEUE",
  INFO_UPDATE = "INFO_UPDATE",
}
